module.exports = __webpack_public_path__ + "img/9788956607740.f0b0c8ca.jpg";